import { render, staticRenderFns } from "./Osa014.vue?vue&type=template&id=0edfbd24&scoped=true"
var script = {}
import style0 from "./Osa014.vue?vue&type=style&index=0&id=0edfbd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edfbd24",
  null
  
)

export default component.exports